import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications'


export default class AddBatch extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      batch: {item:this.props.item, name:"", expiry_date:null, mfg_date:null, closing_purchase_basic_rate:0, closing_stock:0}
    }
    this.handleInputChange = this.handleInputChange.bind(this)

    this.handleDateChange = this.handleDateChange.bind(this)
    this.submit = this.submit.bind(this)

  }
  submit() {
    this.setState({submitting:true})


    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_batch/"
    }
    else {
      apiurl  = "/create_new_batch/"
    }


    axios({
      url: apiurl,
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.batch
    }).then((response)=> {
      if(response.status === 200) {
        this.setState({batch:response.data.batch, submitting:false})
        if(typeof this.props.onAddCallback !== "undefined") {
          this.props.onAddCallback(response.data.batch)
          this.setState({
            batch: {item:this.props.item, name:"", expiry_date:null, mfg_date:null, closing_purchase_basic_rate:0, closing_stock:0}
          })
        }
        else {
          if(this.state.mode==="edit") {
            NotificationManager.success("Updated Batch successfully")
          }
          else {
            NotificationManager.success("Created Batch successfully")
          }
        }
      }
    }).catch((err)=> {
      console.log(err);
      this.setState({submitting:false})
    })

  }
  handleInputChange(e) {
    var name = e.target.name
    var value = e.target.value
    let batch = this.state.batch
    batch[name] = value
    this.setState({batch:batch})
  }
  handleDateChange(e) {
    var name = e.target.name
    var value = e.target.value
    let batch = this.state.batch
    batch[name] = value
    this.setState({batch:batch})
  }
  render() {

    let while_purchasing = this.props.while_purchasing
    let className = "col-md-3"
    let qnty, cl_p_rate
    if(typeof while_purchasing === "undefined" || while_purchasing === null) {
      className = "col-md-2"
      qnty  = <div className="col-md-1">
      <div>
      Quantity
      </div>
        <input type="number" className="form-control input-sm"  name="closing_stock" onChange={this.handleInputChange} />
      </div>
      cl_p_rate = <div className="col-md-2">
      <div>
      Closing Purchase Rate
      </div>
        <input type="text" className="form-control input-sm"  name="closing_purchase_basic_rate" onChange={this.handleInputChange} />
      </div>
    }

    let submitButton = <button className="btn btn-success btn-sm" onClick={this.submit}>Save</button>
    if(this.state.submitting) {
      submitButton = <button className="btn btn-success btn-sm" disabled>Saving..</button>
    }

    return <div className="row row-consise">
    <div className={className}>
      <div>
      Name
      </div>
      <input type="text" className="form-control input-sm"  name="name" onChange={this.handleInputChange} placeholder="name" />
    </div>
    <div className={className}>
    <div>
    Mfg Date
    </div>
      <input type="date" className="form-control input-sm"  name="mfg_date" onChange={this.handleDateChange} />
    </div>
    <div className={className}>
    <div>
    Expiry Date
    </div>
      <input type="date" className="form-control input-sm"  name="expiry_date" onChange={this.handleDateChange} />
    </div>


    {qnty} {cl_p_rate}



    <div className="col-md-1">
    <div>
    &nbsp;
    </div>
    {submitButton}
    </div>


    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/batch/addbatch.js